import {
    renderComponent,
    renderPage,
} from './components/migration/MigrationRoot';

const componentFunctions = {
    renderFooter: renderComponent(() => import('./components/footer/Footer')),
    renderODAppSunsetLibbyFooterPromo: renderComponent(
        () =>
            import(
                './libby/components/libby-footer-promo/subtypes/od-app-sunset/ODAppSunsetLibbyFooterPromo'
            )
    ),
    renderTourismLibbyFooterPromo: renderComponent(
        () =>
            import(
                './libby/components/libby-footer-promo/subtypes/tourism/TourismLibbyFooterPromo'
            )
    ),
    renderGenericLibbyFooterPromo: renderComponent(
        () =>
            import(
                './libby/components/libby-footer-promo/subtypes/generic/GenericLibbyFooterPromo'
            )
    ),
    renderPartnerLibraries: renderComponent(
        () => import('./components/partner-libraries/PartnerLibraries')
    ),
    renderSampleOnlyBanner: renderComponent(
        () => import('./components/banner/SampleOnlyBanner')
    ),
    renderTryLibbyModal: renderComponent(
        () => import('./libby/components/try-libby-modal/TryLibbyModal')
    ),
    renderWindowsAppDownloadMessage: renderComponent(
        () =>
            import(
                './components/windows-app-download-message/WindowsAppDownloadMessage'
            )
    ),
    renderAccessEndingModal: renderComponent(
        () => import('./components/access-ending-modal/AccessEndingModal')
    ),
    renderNtcNavigation: renderComponent(
        () => import('./ntc/components/navigation/NtcNavigation')
    ),
};

const pageFunctions = {
    renderNtcDetailPage: renderPage(() => import('./ntc/pages/NtcDetailPage')),
    renderNtcFaqPage: renderPage(
        () => import('./ntc/pages/NtcFaqPage/NtcFaqPage')
    ),
    renderNtcHomePage: renderPage(
        () => import('./ntc/pages/NtcHomePage/NtcHomePage')
    ),
    renderOdAppSunsetPage: renderPage(
        () =>
            import(
                './overdrive-app/components/od-app-sunset-message/OdAppSunsetPage'
            )
    ),
};

document.dispatchEvent(
    new CustomEvent('react-components-ready', {
        detail: componentFunctions,
    })
);

document.dispatchEvent(
    new CustomEvent('react-pages-ready', {
        detail: pageFunctions,
    })
);
